<div class="modal-backdrop">
  <div class="modal-content">
    <div class="modal-header">
      <h2>{{ title }}</h2>
      <button class="close-button" (click)="close()">
        <img src="assets/icons/close-modal.svg" alt="{{ translate('common.cancel') }}" />
      </button>
    </div>
    <div class="modal-body">
      <div class="legal-content" [innerHTML]="content"></div>
    </div>
    <div class="modal-footer">
      <button class="btn-primary" (click)="close()">{{ translate('common.cancel') }}</button>
    </div>
  </div>
</div>
